import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/services/firebase";
import { getOrCreateDeviceId } from "../../../utils/deviceId";

function normalizeStoredToken(entry) {
  if (!entry) return null;

  if (typeof entry === "string") {
    const token = entry.trim();
    return token ? { token, platform: "web" } : null;
  }

  const token = typeof entry.token === "string" ? entry.token.trim() : "";
  if (!token) return null;

  return {
    ...entry,
    token,
    platform: entry.platform || "web",
  };
}

/**
 * Enregistre le token FCM dans users/{uid}.fcmTokens comme source de vérité canonique.
 * @param {string} userId
 * @param {string} token
 * @param {string} platform - "web-chrome", "web-firefox" ou "web-safari"
 */
export default async function saveFcmToken(userId, token, platform = "web-chrome") {
  const normalizedUserId = String(userId || "").trim();
  const normalizedToken = String(token || "").trim();

  if (!normalizedUserId || !normalizedToken) return;

  const userRef = doc(db, "users", normalizedUserId);
  const userSnap = await getDoc(userRef);
  const userData = userSnap.exists() ? userSnap.data() || {} : {};
  const existingTokens = Array.isArray(userData.fcmTokens) ? userData.fcmTokens : [];

  const now = new Date().toISOString();
  const deviceId = getOrCreateDeviceId();
  const userAgent = navigator.userAgent || "unknown";

  const normalizedEntries = existingTokens.map(normalizeStoredToken).filter(Boolean);
  const previousEntry = normalizedEntries.find(
    (entry) => entry.token === normalizedToken || (deviceId && entry.deviceId === deviceId)
  );

  const nextEntry = {
    token: normalizedToken,
    platform,
    deviceId,
    userAgent,
    createdAt: previousEntry?.createdAt || now,
    updatedAt: now,
  };

  const dedupedEntries = normalizedEntries.filter(
    (entry) => entry.token !== normalizedToken && (!deviceId || entry.deviceId !== deviceId)
  );

  await setDoc(
    userRef,
    {
      fcmTokens: [...dedupedEntries, nextEntry],
    },
    { merge: true }
  );
}
